<template>
	<div
		class="homepage-audit-tests"
		v-if="auditTests && auditTests.length"
	>
		<template v-if="notificationView">
			<div class="audit-notifications">
				<div
					v-for="(auditTest, index) in auditTests"
					:key="auditTest.id || index"
				>
					<f7-link
						class="audit-notification"
						@click="$emit('goToAudit', auditTest.id)"
					>
						<div class="audit-notification__date">{{ createdDateOf(auditTest) }}</div>
						<div class="audit-notification__message">{{ notificationTextOf(auditTest) }}</div>
					</f7-link>
					<hr
						class="audit-notification__divider"
						v-if="index < auditTests.length - 1 || hasItemsBelow"
					/>
				</div>
			</div>
		</template>

		<template v-else>
			<div class="homepage-audit-tests__header" v-if="showTitle">
				<div class="homepage-audit-tests__title section-header__title">Accountability Audits</div>
			</div>

			<div class="current-training__action-list">
				<f7-link
					v-for="(auditTest, index) in auditTests"
					:key="auditTest.id || index"
					class="action-item"
					@click="$emit('goToAudit', auditTest.id)"
				>
					<div class="action-item__icon-wrapper">
						<i
							class="fa fa-list"
							aria-hidden="true"
							style="font-size: 50px"
						></i>
						<ItemDoneMark v-if="isDone(auditTest)" />
					</div>
					<div class="action-name">
						<div class="name">{{ auditNameOf(auditTest) }}</div>
						<div class="created-date" v-if="createdDateOf(auditTest)">{{ createdDateOf(auditTest) }}</div>
					</div>
				</f7-link>
			</div>
		</template>
	</div>
</template>
<script>
	import ItemDoneMark from "@/components/ItemDoneMark.vue";

	export default {
		props: {
			auditTests: Array,
      showTitle: {
        type: Boolean,
        default: true
      },
      notificationView: {
        type: Boolean,
        default: false
      },
      hasItemsBelow: {
        type: Boolean,
        default: false
      },
		},

		components: {
			ItemDoneMark,
		},

		methods: {
			auditNameOf(auditTest) {
				return (auditTest.audit && auditTest.audit.name)
					|| auditTest.action
					|| auditTest.name;
			},

			notificationTextOf(auditTest) {
				return (auditTest.audit && auditTest.audit.notificationMessage)
					|| this.auditNameOf(auditTest);
			},

			createdDateOf(auditTest) {
				if (!auditTest.createdAt) return "";

				const date = new Date(auditTest.createdAt);

				if (isNaN(date.getTime())) return "";

				const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
				const rest = date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

				return `${weekday}. ${rest}`;
			},

			questionsOf(auditTest) {
				const questions = auditTest.audit && auditTest.audit.questions ? auditTest.audit.questions : [];

				return questions.filter((q) => q.type !== 9);
			},

			answeredOf(auditTest) {
				return this.questionsOf(auditTest).filter((q) => q.answers && q.answers.some((a) => a.result)).length;
			},

			isDone(auditTest) {
				const total = this.questionsOf(auditTest).length;
				return total > 0 && this.answeredOf(auditTest) === total;
			},
		},
	};
</script>
<style lang="scss">
	.homepage-audit-tests {
		padding: 0 24px;

		&__header {
			margin-left: 0;
			margin-right: 0;
		}

		.current-training__action-list .action-item {
			overflow: hidden;
			border: solid 2px var(--card-border-color);
			border-radius: 16px;

			&__icon-wrapper {
				flex-basis: 25%;
				aspect-ratio: 1/1;
				border-right: solid 2px var(--card-border-color);

				@media (max-width: 425.22px) {
					flex-basis: 25%;
				}
				@media (max-width: 375.22px) {
					flex-basis: 32%;
				}
			}
		}

		.current-training__action-list .action-item .action-name {
			flex-direction: column;
			align-items: flex-start;
			justify-content: space-between;
			flex-grow: 1;
			padding: 0;

			.name {
				flex-grow: 1;
				margin: 10px 5px 10px 10px;

				font-weight: 600;
				font-size: 20px;
				line-height: 120%;

				@media (max-width: 375.222px) {
					margin-bottom: 5px;
					font-size: 16px;
				}
			}

			.created-date {
				margin-left: 10px;
				margin-bottom: 3px;
				margin-right: 5px;

				font-family: "Urbanist";
				font-weight: 500;
				font-size: 12px;
				line-height: 130%;
				letter-spacing: 0.2px;
				text-align: left;
				opacity: 0.7;

				@media (max-width: 375.222px) {
					font-size: 10px;
				}
			}
		}

		.audit-notifications {
			.audit-notification {
				display: block;
				width: 100%;
				color: inherit;
				text-align: left;

				&__date {
					margin-bottom: 16px;
				}

				&__message {
					line-height: 1.4;
				}
			}

			.audit-notification__divider {
				border: none;
				border-top: 1px solid currentColor;
				opacity: 0.6;
				margin: 20px 0;
			}
		}
	}
</style>
